import Vue from "vue";
import Vuex from "vuex";
import permission from './modules/permission.js';
import tabRouter from './modules/tab-router.js'; // 多标签管理
import loading from './modules/loading.js'; // 全局请求 loading 计数
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userinfo: {},
    token: "",
    infostore: {},
    homeinfo:{}
  },
  getters: {},
  mutations: {
    setinfo(state, userinfo) {
      state.userinfo = userinfo;
    },
    setstore(state, infostore) {
      state.infostore = infostore;
    },
    sethome(state, homeinfo) {
       state.homeinfo = homeinfo;
    }
  },
  actions: {},
  modules: {
    permission,
    tabRouter,
    loading,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js